import { HeartPulse, Bandage, Spline, CircleDot, Flame, Layers, MoveDown, ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";

const CONDITIONS = [
  {
    icon: HeartPulse,
    title: "Emorroidi",
    text: "Diverse possibilità terapeutiche per affrontare il problema con serenità.",
    id: "emorroidi",
  },
  {
    icon: Bandage,
    title: "Ragadi anali",
    text: "Dalla cura conservativa alle opzioni più avanzate: nessuna paura, solo chiarezza.",
    id: "ragadi",
  },
  {
    icon: Spline,
    title: "Fistola perianale",
    text: "Valutazione accurata e percorso mirato, spiegato con parole semplici.",
    id: "fistola",
  },
  {
    icon: CircleDot,
    title: "Cisti pilonidale",
    text: "Percorso dedicato, con attenzione al tuo comfort e ai tempi di recupero.",
    id: "cisti",
  },
  {
    icon: Flame,
    title: "Ascesso",
    text: "Trattamento tempestivo, con attenzione al tuo comfort.",
    id: "ascesso",
  },
  {
    icon: Layers,
    title: "Diverticolosi",
    text: "Percorso dedicato alla salute del colon, dal controllo alla cura.",
    id: "diverticolosi",
  },
  {
    icon: MoveDown,
    title: "Prolasso rettale",
    text: "Valutazione attenta del prolasso e del pavimento pelvico, con opzioni su misura.",
    id: "prolasso",
  },
  {
    cta: true,
    title: "Non sai quale sia il tuo caso?",
    text: "Nessun tabù: prenota una valutazione generale e parliamone con calma.",
    id: "generale",
  },
];

export default function Conditions() {
  return (
    <section id="trattamenti" className="relative py-28">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal>
          <p className="eyebrow">Cosa tratto</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-4 tracking-tight max-w-3xl">
            Diverse possibilità terapeutiche, <span className="italic text-gold">valutate caso per caso</span>
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
          {CONDITIONS.map((c, i) => {
            const Icon = c.icon;
            return c.cta ? (
              <Reveal key={c.id} delay={i * 0.08} className="h-full">
                <a
                  href="#prenota"
                  data-testid="condition-unknown-cta"
                  className="group h-full flex flex-col justify-between rounded-3xl border border-gold/40 bg-gradient-to-br from-gold/15 to-sage/20 p-7 transition-all duration-500 hover:border-gold hover:-translate-y-1.5"
                >
                  <div>
                    <span className="flex items-center justify-center w-12 h-12 rounded-2xl bg-gold text-ink">
                      <ArrowRight size={22} />
                    </span>
                    <h3 className="font-display text-2xl mt-6 text-ivory">{c.title}</h3>
                    <p className="text-sm text-silver leading-relaxed mt-3">{c.text}</p>
                  </div>
                  <span className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-gold mt-6">
                    Prenota ora
                    <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
                  </span>
                </a>
              </Reveal>
            ) : (
              <Reveal key={c.id} delay={i * 0.08} className="h-full">
                <a
                  href="#prenota"
                  data-testid={`condition-card-${c.id}`}
                  className="group h-full flex flex-col rounded-3xl border border-white/10 bg-card p-7 transition-all duration-500 hover:border-gold/40 hover:-translate-y-1.5 hover:shadow-[0_20px_50px_rgba(212,163,89,0.12)]"
                >
                  <span className="flex items-center justify-center w-12 h-12 rounded-2xl bg-gold/10 border border-gold/20 text-gold transition-colors group-hover:bg-gold group-hover:text-ink">
                    <Icon size={22} />
                  </span>
                  <h3 className="font-display text-2xl mt-6 text-ivory">{c.title}</h3>
                  <p className="text-sm text-silver leading-relaxed mt-3 flex-1">{c.text}</p>
                  <span className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-gold mt-6">
                    Parlane con me
                    <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
                  </span>
                </a>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
